// #region Type
export const ACTION_TYPE = {
  CALL_API_INIT_MAIL_MAGAZINE_ENTRY: 'CALL_API_INIT_MAIL_MAGAZINE_ENTRY',
  CALL_API_INIT_MAIL_MAGAZINE_ENTRY_SUCCESS: 'CALL_API_INIT_MAIL_MAGAZINE_ENTRY_SUCCESS',
  CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS: 'CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS',
  RESET_MAIL_MAGAZINE_MEMBERS: 'RESET_MAIL_MAGAZINE_MEMBERS',
  CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS_SUCCESS: 'CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS_SUCCESS',
  CALL_API_MAIL_TEMPLATES: 'CALL_API_MAIL_TEMPLATES',
  CALL_API_MAIL_TEMPLATES_SUCCESS: 'CALL_API_MAIL_TEMPLATES_SUCCESS',
};
// #endregion

// #region Type
export const actCallInitMailMagazineEntry = () => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_ENTRY,
});

export const actCallInitMailMagazineEntrySuccess = (selects) => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_ENTRY_SUCCESS,
  selects,
});

export const actCallMailMagazineEntryMembers = (searchCondition) => ({
  type: ACTION_TYPE.CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS,
  searchCondition,
});

export const actResetMailMagazineMembers = () => ({
  type: ACTION_TYPE.RESET_MAIL_MAGAZINE_MEMBERS,
});

export const actCallMailMagazineEntryMembersSuccess = (members) => ({
  type: ACTION_TYPE.CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS_SUCCESS,
  members,
});

export const actCallMailTemplates = (storeId) => ({
  type: ACTION_TYPE.CALL_API_MAIL_TEMPLATES,
  storeId,
});

export const actCallMailTemplatesSuccess = (templates) => ({
  type: ACTION_TYPE.CALL_API_MAIL_TEMPLATES_SUCCESS,
  templates,
});
// #endregion
